<script>
    import wait from '../../libs/wait';
    export let classes = 'btn btn-primary'
    export let click = (e) => { }

    let touchstartTriggered = false
    let button = null

    const handleClick = (e) => {
        if (!touchstartTriggered)
            click (e);
    }
    const handleTouchStart = (e) => {
        touchstartTriggered = true;
        if (button)
            button.style.transform = 'scale(0.9)';
    }

    const handleTouchEnd = (e) => {
        if (button)
            button.style.transform = 'scale(1)';
        wait (250).then (click.call (this, e))
    }
</script>

<button bind:this={button} class={"touch-button " + classes} 
    on:click={handleClick} 
    on:touchstart={handleTouchStart} 
    on:touchend={handleTouchEnd}>
    <slot>No Label</slot>
</button>

<style>
    .touch-button {
        transition: all 0.15s;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    } 

    @media(max-width: 400px) {
        .touch-button {
            padding: .65rem .75rem;
        }
    }
</style>